import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/pro-regular-svg-icons';

// manor
import { Modal } from '@comparethemarketau/manor-modal';
import { MobileLayout } from '@comparethemarketau/manor-layout';

import { Separator } from '../common/separator';
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { QuoteReference } from '../common/quote_reference';

import { CallBackForm } from './call_back_form';
import { CallDirectInformation } from './call_direct_information';

const useStyles = createUseStyles((theme) => ({
    titleIcon: {
        display: 'flex',
        height: '100%',
        fontSize: theme.fontSize['2xl'],
        alignItems: 'center'
    },
    getInTouchContentContainer: {
    }
}));

const _ProductGetInTouchModal = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { visible, onClose, contactIsCallBackAllowed, contactIsCallDirectAllowed, productId, providerName,
        providerQuoteNumber, contactPhoneNumber, contactCallCentreHours, cleanupState } = props;

    const handleClose = () => {
        onClose(false);
        cleanupState();
    };

    return (
        <div className={classNames('test-policyProductCard-getInTouchModal')}>
            <Modal
                trackingLabel={`Get in touch with ${providerName} for ${productId}`}
                visible={visible}
                title="Get in touch"
                titleIcon={<MobileLayout className={classes.titleIcon}><FontAwesomeIcon icon={faPhoneAlt} /></MobileLayout>}
                handleClose={handleClose}
                handleOverlayClick={handleClose}
                overlay
            >
                <div className={classes.getInTouchContentContainer}>
                    <QuoteReference quoteNumber={providerQuoteNumber} />
                    {contactIsCallDirectAllowed && <CallDirectInformation phoneNumber={contactPhoneNumber} callCentreHours={contactCallCentreHours} />}
                    {contactIsCallDirectAllowed && contactIsCallBackAllowed && <Separator type="horizontal" />}
                    {contactIsCallBackAllowed && <CallBackForm productId={productId} providerName={providerName} />}
                </div>
            </Modal>
        </div>
    );
};

_ProductGetInTouchModal.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func,

    quote: PropTypes.object.isRequired,
    contactIsCallBackAllowed: PropTypes.bool,
    contactIsCallDirectAllowed: PropTypes.bool,
    productId: PropTypes.string,
    providerName: PropTypes.string,
    providerQuoteNumber: PropTypes.string,
    contactPhoneNumber: PropTypes.string,
    contactCallCentreHours: PropTypes.string,

    cleanupState: PropTypes.func

};

const mapDispatchToProps = (dispatch) => ({
    cleanupState: () => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'callBackSuccess',
            value: false
        });
    }
});

const ProductGetInTouchModal = withQuoteFlatten(connect(null, mapDispatchToProps)(_ProductGetInTouchModal));

export { ProductGetInTouchModal };
